module.exports = __webpack_public_path__ + "img/play-solid.b0a1fc26.svg";